
import type { FetchResult } from 'apollo-link'
import { defineComponent } from 'vue'

import DowngradeToFreePlanMutation from '~/apollo/mutations/owner/downgradeToFreePlan.gql'
import ActiveUserMixin, { type DashboardContext } from '~/mixins/activeUserMixin'
import OwnerDetailMixin from '~/mixins/ownerDetailMixin'
import { TeamPerms } from '~/types/permTypes'
import type { DowngradeToFreePlanMutation as DowngradeToFreePlanMutationType } from '~/types/types'

const pauseImagePng = require('~/assets/images/ui-states/subscription-paused.png')
const pauseImageWebp = require('~/assets/images/ui-states/subscription-paused.webp')

export default defineComponent({
  name: 'SubscriptionPausedState',

  mixins: [ActiveUserMixin, OwnerDetailMixin],

  data() {
    return {
      pauseImagePng,
      pauseImageWebp,
      isDowngrading: false,
      showConfirmDialog: false
    }
  },

  computed: {
    isAdmin(): boolean {
      const ctx = this.activeDashboardContext as DashboardContext
      return (
        ctx?.type !== 'user' &&
        this.$gateKeeper.team(TeamPerms.UPDATE_BILLING_DETAILS, this.teamPerms.permission)
      )
    },
    contactSalesUrl(): string {
      const base = this.$config.salesUrl
      const params = new URLSearchParams()
      if (this.viewer?.firstName) params.set('first_name', this.viewer.firstName)
      if (this.viewer?.lastName) params.set('last_name', this.viewer.lastName)
      if (this.viewer?.email) params.set('email', this.viewer.email)
      const qs = params.toString()
      return qs ? `${base}?${qs}` : base
    }
  },

  methods: {
    navigateToCheckout() {
      const { provider, owner } = this.$route.params
      if (!provider || !owner) return

      this.$router.push(
        this.$generateRoute(['settings', 'billing', 'checkout'], false, true, provider, owner)
      )
    },

    async downgradeToFreePlan(close?: () => void) {
      if (this.isDowngrading || !this.owner?.id) return

      this.isDowngrading = true
      try {
        const result: FetchResult<DowngradeToFreePlanMutationType> =
          await this.$applyGraphqlMutation(DowngradeToFreePlanMutation, {
            ownerId: this.owner.id
          })

        const payload = result.data?.downgradeToFreePlan
        if (payload?.error) {
          this.$toast.danger(payload.error)
          this.isDowngrading = false
        } else {
          if (close) close()
          window.location.reload()
        }
      } catch (e) {
        this.$logErrorAndToast(e as Error, 'Failed to downgrade plan. Please try again.')
        this.isDowngrading = false
      }
    }
  }
})
